import React, { useCallback, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { doChipStore } from '../../store/doChipStore';
import { useRouletteDoBetValidation } from '../../hooks/useRouletteDoBetValidation';
import { autoBetStore } from '../../store/autoBetStore';
import { freeBetStore, notificationStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { gameStore } from '../../store/gameStore';
import { allChipsTotal } from '../../helpers/chipsTotal';
import { betResponseCodeByName } from '../../enums/betResponseCode';
import { soundService, soundTypes } from '../../services/SoundService';
import { winningAmountStore } from '../../store/winningAmountStore';
import {ChipsContainer, iframeService, platformMessageStore} from '@pascal/pascal-core';
import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';
import {PlatformErrorCodes} from "../../enums/platformEnums";

export const GameChipsContainer = observer(() => {
  const {
    selectedChip,
    setSelectedChip,
    setUndoBet,
    quickBets,
    reBet,
    getAllBetsModels: allBetsModels,
    setAllBetsModel,
  } = doChipStore;
  const { handleDoubleBetWithValid } = useRouletteDoBetValidation();
  const { balance } = userInfoStore;
  const handleSelectChips = useCallback((chip) => setSelectedChip(chip), []);
  const { isBetsClosed } = gameStore;
  const ref = useRef();
  const { setLastWin } = winningAmountStore;
  const { activeFreeBet } = freeBetStore;

  const handleUndo = () => {
    if (autoBetStore.autoBetModel) {
      autoBetStore.resetAutoBet();
    }
    if (allBetsModels.length && !isBetsClosed) {
      userSettingsStore.isSoundOn && soundService.play(soundTypes.chip);
      setLastWin(0);
      setUndoBet();
    }
  };

  const handleDouble = () => {
    if (reBet && !allBetsModels.length && allChipsTotal(reBet.lastBetModel) <= balance && !isBetsClosed) {
      if (autoBetStore.autoBetModel) {
        autoBetStore.resetAutoBet();
      }
      setLastWin(0);
      setAllBetsModel([reBet.lastBetModel]);
      return;
    }
    if (reBet && !allBetsModels.length && allChipsTotal(reBet.lastBetModel) > balance && !isBetsClosed) {
      !platformMessageStore.isShowAllNotification ? iframeService.sendErrorReceived(
          {"errorCode": PlatformErrorCodes.NotEnoughMoney}
      ) : notificationStore.setNotificationType(betResponseCodeByName.NotEnoughBalance)

      setTimeout(() => {
        notificationStore.setNotificationType(null);
      }, 1000);
      return;
    }
    if (allBetsModels.length && !isBetsClosed) {
      handleDoubleBetWithValid();
    }
  };

  return (
    <div className='main-game-bet-cont'>
      <div className='game-betting-amount-wrp'>
        <button className={`main-bet-btn ${allBetsModels.length ? 'active' : ''}`} onClick={handleUndo}>
          <span className='icon-arrow-back' />
        </button>
        <ChipsContainer
          selectedChip={selectedChip}
          isFreeChip={!!activeFreeBet.id}
          handleSelectChips={handleSelectChips}
          quickBets={quickBets}
        />
        {/*<div className="icon-chips-wrp" onClick={() => scroll('left')}><i className="icon-arrow-left"/></div>*/}
        {/*<div className="main-bet-wrp" ref={ref}>*/}
        {/*  <div className="main-bet-inner-cont">{memoChip}</div>*/}
        {/*</div>*/}
        {/*<div className="icon-chips-wrp" onClick={scroll}><i className="icon-arrow-right"/></div>*/}
        <button className='main-bet-btn' onClick={handleDouble}>
          <span className={reBet && !allBetsModels.length ? 'icon-spinner' : 'icon-double'} />
        </button>
      </div>
    </div>
  );
});
